import { FaqAccordion } from "components/Accordion";
import { BlockHeading } from "components/landing-pages/BlockHeading";
import { FaqBlock } from "dtos/content/landing-pages/FaqBlock";

export const FaqBlockDisplay = (props: { block: FaqBlock }) => {
    const { block } = props;
    const { faqs, sortOrder, heading } = block;

    return (
        <div className="grid">
            {heading && (
                <div className="g-col-12">
                    <BlockHeading block={block} />
                </div>
            )}

            <div className="g-col-12 g-col-lg-8">
                <FaqAccordion id={`faq-accordion-${sortOrder}`} items={faqs} />
            </div>
        </div>
    );
};
